import { useMemo } from 'react';
import { getMockScenarioData } from '../../services/mock/applicationData';
import { parseApplicationData } from '../../services/util/queryResultsTransformers';

/**
 * Hook that provides mock data in RTK Query format
 * Bypasses API calls completely for test scenarios
 * @param {string} scenarioKey - Mock scenario key
 * @returns {Object} RTK Query-like response object
 */
export const useMockData = (scenarioKey) => {
  return useMemo(() => {
    try {
      const mockData = getMockScenarioData(scenarioKey);
      const parsedData = parseApplicationData(mockData);
      
      return {
        data: parsedData,
        isLoading: false,
        isError: false,
        error: null,
        isSuccess: true,
        isFetching: false,
        refetch: () => Promise.resolve({ data: parsedData })
      };
    } catch (error) {
      return {
        data: null,
        isLoading: false,
        isError: true,
        error: { message: `Failed to load mock scenario: ${scenarioKey}` },
        isSuccess: false,
        isFetching: false,
        refetch: () => Promise.reject(error)
      };
    }
  }, [scenarioKey]);
};

export default useMockData;